var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPageWithLinesIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "e1oo6yw53a",
    width: "125.6%",
    height: "125.3%",
    x: "-12.8%",
    y: "-12.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 16,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.188235294 0 0 0 0 0.192156863 0 0 0 0 0.2 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0.188235294 0 0 0 0 0.192156863 0 0 0 0 0.2 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    filter: "url(#e1oo6yw53a)",
    transform: "translate(-264 -94)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.72 7.333c1.035.003 2.02.442 2.713 1.21l19.947 22c.611.673.95 1.548.953 2.457v38.501c-.06 5.123-4.263 9.227-9.386 9.166H23.783c-5-.084-9.057-4.134-9.116-9.167V16.499c.06-5.123 4.263-9.227 9.386-9.166zm-25.673 7.333c-1.072-.059-1.988.762-2.047 1.834v55.006c.063 1.072.982 1.89 2.053 1.827h39.9c1.072.06 1.988-.761 2.047-1.833V36.667H53.937c-5.622-.16-10.06-4.828-9.937-10.45v-11.55zm30.953 44c2.025 0 3.667 1.642 3.667 3.667S57.025 66 55 66H33c-2.025 0-3.667-1.642-3.667-3.667s1.642-3.666 3.667-3.666zM44 44c2.025 0 3.667 1.642 3.667 3.667S46.025 51.333 44 51.333H33c-2.025 0-3.667-1.641-3.667-3.666S30.975 44 33 44zm7.333-25.667v7.884l-.003.05c-.097 1.597 1.12 2.97 2.717 3.066h7.333l-10.047-11z",
    transform: "translate(264 94)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPageWithLinesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pageWithLinesIcon.61313371.svg";
export { ForwardRef as ReactComponent };